import Vue from 'vue';
var numeral = require('numeral');

numeral.register('locale', 'cml', {
    delimiters: {
        thousands: currency_format.thousand_separator,
        decimal: currency_format.decimal_separator
    }
});

numeral.locale('cml');

Vue.mixin({
    data: function () {
        return {
            load: 0,
        }
    },
    methods: {
        unset: (array, index) => {
            array.splice(index, 1);
        },
        clone: (obj, vm) => {
            if (obj === null || typeof (obj) !== 'object' || 'isActiveClone' in obj)
                return obj;

            if (obj instanceof Date)
                var temp = new obj.constructor(); //or new Date(obj);
            else
                var temp = obj.constructor();

            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    obj['isActiveClone'] = null;
                    temp[key] = vm.clone(obj[key], vm);
                    delete obj['isActiveClone'];
                }
            }

            return temp;
        },
        nl2br: str => {
            if (typeof str === 'undefined' || str === null) {
                return '';
            }
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br/>' + '$2');
        },
        loader: (status) => {
            if (status) {
                $('.overlay').html('<div class="loader mx-auto"></div>').css({ opacity: 1, display: 'flex', 'align-items': 'center' });
            } else {
                $('.overlay').css('opacity', 0).delay(300).hide().html('');
            }
        },
        vmModal: (status, modal, object, form_object) => {
            if (object != undefined && form_object != undefined) {
                for (var key in form_object) {
                    form_object[key] = object[key];
                }
            }
            $(modal).modal(status);
        },
        trashObject: (object) => {
            for (var key in object) {
                if (typeof object[key] == 'object') {
                    object[key] = [];
                } else if (typeof object[key] == 'number') {
                    object[key] = 0;
                } else {
                    object[key] = '';
                }
            }

            return object;
        },

        arrayKeyExits: (key, object) => {
            if (object != undefined) {
                return key in object;
            }

            return false;
        },

        inArray: (value, array) => {
            if (array != undefined && value != undefined) {
                for (var i in array) {
                    if (array[i] == value) {
                        return true;
                    }
                }
            }

            return false;
        },

        inArrayKey: (value, key, array) => {
            if (array != undefined && value != undefined, key != undefined) {
                for (var i in array) {
                    if (array[i][key] == value) {
                        return array[i];
                    }
                }
            }

            return false;
        },

        number_format: (number, decimal) => {
            if(decimal == undefined){
                decimal = true;
            }
            if(decimal){
                return numeral(number).format('0,0.' + '000000000'.substring(0, currency_format.decimal_number));
            }else{
                return numeral(number).format('0,0');
            }
        },

        currency_format: (number) => {
            return numeral(parseFloat(number)).format('0,0.' + '000000000'.substring(0, currency_format.decimal_number)) + ' ' + currency_format.currency;
        },

        isInt: (n) => {
            return Number(n) === n && n % 1 === 0;
        },

        __: (key, msg) => {
            if(translate != undefined && key != undefined){
                let key_split = key.split('.');
                let trans_name = key_split[0];
                key_split.splice(0, 1);
                key_split = key_split.join('.');

                if((trans_name in translate) && (key_split in translate[trans_name])){
                    var trans = translate[trans_name][key_split];
                    if(msg != undefined){
                        trans = trans.replace(msg.key, msg.value);
                    }
                    return trans;
                }
            }

            return key;
        },

        errorHandler: (error) => {
            if(error != undefined){
                if(error.status == 400 && error.data.status != undefined && error.data.status == 'not_project') {
                    window.location.reload();
                }else if(error.status == 422 && error.data != undefined) {
                    $('[data-error-container]').addClass('d-none');
                    for(var key in error.data.errors){
                        $('[data-error-container="' + key + '"]').html(error.data.errors[key][0]).removeClass('d-none');
                        $('[data-error-container="' + key + '"]').parents('.form-group').addClass('has-error');
                        $('[data-error-container="' + key + '"]').parents('.form-group').find('.form-control').addClass('has-error');
                    }
                }
            }else{
                window.location.reload();
            }
        },

        loader: (diretion, msg) => {
            if(diretion == 'add'){
                this.load += 1;
            }else if(diretion == 'remove_all'){
                this.load = 0;
            }else if(diretion == 'add_one'){
                this.load = 1;
            }else{
                this.load -= 1;
            }
            $('#loader-wrapper .loader-msg').show();
            if(msg == false){
                $('#loader-wrapper .loader-msg').hide();
            }

            if(this.load > 0){
                $('body').addClass('loaded');
            }else{
                $('body').removeClass('loaded');
                this.load = 0;
            }
        },
        getDate(date){
            if(date == undefined){
                var date = new Date();
            }
            return date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? ('0' + (date.getMonth() + 1)) : date.getMonth() + 1) + '-' + (date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate());
        },
        getDateTime(date){
            if(date == undefined){
                var date = new Date();
            }
            return date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? ('0' + (date.getMonth() + 1)) : date.getMonth() + 1) + '-' + (date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()) + ' ' + (date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()) + ':' + (date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes());
        },

        baseUrl(uri){
            return Laravel.baseApiUrl + '/' + uri;
        },

        setRating(type, rate){
            $('.stars i').removeClass('hover').removeClass('selected');
            for(var i = 0; i < rate; i++){
                $('.stars i').eq(i).addClass(type == 'over' ? 'hover' : 'selected');
            }

            if(type == 'click'){
                this.rate = rate;
            }
        },

        filterItemSort(array, checked, container){
            let selected = [];
            let unselected = [];
            for(var i in array){
                if(this.inArray(array[i].id, checked)){
                    selected.push(array[i]);
                }else{
                    unselected.push(array[i]);
                }
            }
            selected.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
            unselected.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
            
            setTimeout(() => {
                $(`.${container}-container input`).removeAttr('checked').prop('checked', false);
                for(var i in checked){
                    $(`.${container}-container input#${container}-${checked[i]}`).attr('checked', 'checked').prop('checked', true);
                }
            }, 50);

            return selected.concat(unselected);
        }
    }
});
